// Recovered compiled webpack factory 82617. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { m: () => T });
  var n = i(78041),
    s = i(27290),
    r = i(6500),
    o = i(46934),
    a = i(60178);
  let l = {};
  function h(t, e) {
    let i = (0, a.p)(t);
    return () => l[e] ?? i();
  }
  let u = h(() => void 0 !== window.ScrollTimeline, "scrollTimeline");
  var d = i(33855),
    c = i(87671),
    p = i(62213),
    m = i(23867),
    f = i(34324);
  let v = h(() => {
    try {
      document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch (t) {
      return !1;
    }
    return !0;
  }, "linearEasing");
  var y = i(33754);
  let g = ([t, e, i, n]) => `cubic-bezier(${t}, ${e}, ${i}, ${n})`,
    x = {
      linear: "linear",
      ease: "ease",
      easeIn: "ease-in",
      easeOut: "ease-out",
      easeInOut: "ease-in-out",
      circIn: g([0, 0.65, 0.55, 1]),
      circOut: g([0.55, 0, 1, 0.45]),
      backIn: g([0.31, 0.01, 0.66, -0.59]),
      backOut: g([0.33, 1.53, 0.69, 0.99]),
    };
  var w = i(65181);
  class T extends c.q {
    constructor(t) {
      if (
        (super(),
        (this.finishedTime = null),
        (this.isStopped = !1),
        (this.manualStartTime = null),
        !t)
      )
        return;
      let {
        element: e,
        name: i,
        keyframes: s,
        pseudoElement: r,
        allowFlatten: a = !1,
        finalKeyframe: l,
        onComplete: h,
      } = t;
      ((this.isPseudoElement = !!r),
        (this.allowFlatten = a),
        (this.options = t),
        (0, n.V)(
          "string" != typeof t.type,
          'Mini animate() doesn\'t support "type" as a string.',
          "mini-spring",
        ));
      let u = (function ({ type: t, ...e }) {
        return (0, w.W)(t) && v()
          ? t.applyToOptions(e)
          : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
      })(t);
      ((this.animation = (function (
        t,
        e,
        i,
        {
          delay: n = 0,
          duration: s = 300,
          repeat: r = 0,
          repeatType: o = "loop",
          ease: a = "easeOut",
          times: l,
        } = {},
        h,
      ) {
        let u = { [e]: i };
        l && (u.offset = l);
        let d = (function t(e, i) {
          if (e)
            return "function" == typeof e
              ? v()
                ? (0, y.K)(e, i)
                : "ease-out"
              : (0, f.D)(e)
                ? g(e)
                : Array.isArray(e)
                  ? e.map((e) => t(e, i) || x.easeOut)
                  : x[e];
        })(a, s);
        (Array.isArray(d) && (u.easing = d), m.Q.value && p.q.waapi++);
        let c = {
          delay: n,
          duration: s,
          easing: Array.isArray(d) ? "linear" : d,
          fill: "both",
          iterations: r + 1,
          direction: "reverse" === o ? "alternate" : "normal",
        };
        h && (c.pseudoElement = h);
        let w = t.animate(u, c);
        return (
          m.Q.value &&
            w.finished.finally(() => {
              p.q.waapi--;
            }),
          w
        );
      })(e, i, s, u, r)),
        !1 === u.autoplay && this.animation.pause(),
        (this.animation.onfinish = () => {
          if (((this.finishedTime = this.time), !r)) {
            let t = (0, d.X)(s, this.options, l, this.speed);
            (this.updateMotionValue && this.updateMotionValue(t),
              (0, o.e)(e, i, t),
              this.animation.cancel());
          }
          (h?.(), this.notifyFinished());
        }));
    }
    play() {
      this.isStopped ||
        ((this.manualStartTime = null),
        this.animation.play(),
        "finished" === this.state && this.updateFinished());
    }
    pause() {
      this.animation.pause();
    }
    complete() {
      this.animation.finish?.();
    }
    cancel() {
      try {
        this.animation.cancel();
      } catch (t) {}
    }
    stop() {
      if (this.isStopped) return;
      this.isStopped = !0;
      let { state: t } = this;
      "idle" !== t &&
        "finished" !== t &&
        (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(),
        this.isPseudoElement || this.cancel());
    }
    commitStyles() {
      let t = this.options?.element;
      !this.isPseudoElement && t?.isConnected && this.animation.commitStyles?.();
    }
    get duration() {
      let t = this.animation.effect?.getComputedTiming?.().duration || 0;
      return (0, s.X)(Number(t));
    }
    get iterationDuration() {
      let { delay: t = 0 } = this.options || {};
      return this.duration + (0, s.X)(t);
    }
    get time() {
      return (0, s.X)(Number(this.animation.currentTime) || 0);
    }
    set time(t) {
      let e = null !== this.finishedTime;
      ((this.manualStartTime = null),
        (this.finishedTime = null),
        (this.animation.currentTime = (0, s.f)(t)),
        e && this.animation.pause());
    }
    get speed() {
      return this.animation.playbackRate;
    }
    set speed(t) {
      (t < 0 && (this.finishedTime = null), (this.animation.playbackRate = t));
    }
    get state() {
      return null !== this.finishedTime ? "finished" : this.animation.playState;
    }
    get startTime() {
      return this.manualStartTime ?? Number(this.animation.startTime);
    }
    set startTime(t) {
      this.manualStartTime = this.animation.startTime = t;
    }
    attachTimeline({ timeline: t, rangeStart: e, rangeEnd: i, observe: n }) {
      return (this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }),
      (this.animation.onfinish = null),
      t && u())
        ? ((this.animation.timeline = t),
          e && (this.animation.rangeStart = e),
          i && (this.animation.rangeEnd = i),
          r.l)
        : n(this);
    }
  }
}
